var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59998 13.8002C3.59998 9.275 3.59998 7.0118 5.00638 5.6066C6.41278 4.2014 8.67478 4.2002 13.2 4.2002H15.6C20.1252 4.2002 22.3884 4.2002 23.7936 5.6066C25.1988 7.013 25.2 9.275 25.2 13.8002V16.2002C25.2 20.7254 25.2 22.9886 23.7936 24.3938C22.3872 25.799 20.1252 25.8002 15.6 25.8002H13.2C8.67478 25.8002 6.41158 25.8002 5.00638 24.3938C3.60118 22.9874 3.59998 20.7254 3.59998 16.2002V13.8002Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7997 8.39941C20.4624 8.39941 20.9998 8.93696 20.9999 9.59961C20.9999 10.2624 20.4624 10.7998 19.7997 10.7998C19.137 10.7997 18.5995 10.2623 18.5995 9.59961C18.5996 8.93702 19.1371 8.39952 19.7997 8.39941Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3998 19.1998C16.7194 19.1998 18.5998 17.3194 18.5998 14.9998C18.5998 12.6802 16.7194 10.7998 14.3998 10.7998C12.0802 10.7998 10.1998 12.6802 10.1998 14.9998C10.1998 17.3194 12.0802 19.1998 14.3998 19.1998Z",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterInsta);
export default __webpack_public_path__ + "static/media/footerInsta.6a276987b890e89d2fa5f4bb5a2bfc5a.svg";
export { ForwardRef as ReactComponent };